import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDefectDojoLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 439,
	height: 40,
	viewBox: "0 0 439 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M47.1328 15.9225V23.1406V39.7H79.6146V32.4818H54.351V23.1406H69.6366V15.9225H54.351V7.21818H79.6146V0H47.1328V15.9225Z",
			fill: "#5445FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M126.748 15.9225V23.1406V39.7H159.23V32.4818H133.754V23.1406H149.039V15.9225H133.754V7.21818H159.23V0H126.748V15.9225Z",
			fill: "#5445FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M166.449 39.7H198.931V32.4818H173.667V7.21818H198.931V0H166.449V39.7Z",
			fill: "#5445FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M86.834 15.9225V23.1406V39.7H94.0522V32.4818V25.0513V23.1406H109.338V15.9225H94.0522V7.21818H119.528V0H86.834V15.9225Z",
			fill: "#5445FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M246.061 0H229.714H222.495H206.148V7.21818H222.495V39.7H229.714V7.21818H246.061V0Z",
			fill: "#5445FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0 7.21818H9.12888H32.6941V32.4818H7.21818V18.2578H0V39.7H39.9123V0H0V7.21818Z",
			fill: "#5445FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M304.869 39.7H344.781V0H304.869V39.7ZM312.087 7.21818H337.563V32.6941H312.087V7.21818Z",
			fill: "#32C4EC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M398.703 0V39.7H438.615V0H398.703ZM431.185 32.4818H405.709V7.00588H431.185V32.4818Z",
			fill: "#32C4EC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M257.736 7.21818H266.865H290.43V32.4818H264.955V18.2578H257.736V39.7H297.649V0H257.736V7.21818Z",
			fill: "#32C4EC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M384.483 7.21818V21.4422V32.4818H359.007V21.4422H351.789V39.7H391.701V0H384.483V7.21818Z",
			fill: "#32C4EC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.8404 14.2305H13.8008V25.27H24.8404V14.2305Z",
			fill: "#32C4EC"
		})
	]
});
export default SvgDefectDojoLogo;
